export const en = {
  footer: {
    cta: "Start making an impact in your community today",
    copyright: "© Purposely",
    sections: {
      company: {
        title: "Company",
        links: {
          about: "About Us",
          privacy: "Privacy Policy",
          terms: "Terms of Use"
        }
      },
      product: {
        title: "Product",
        links: {
          referral: "Referral Program",
          whatsNew: "What's New",
          blog: "Blog"
        }
      },
      connect: {
        title: "Connect",
        socialAlt: {
          facebook: "Facebook link",
          twitter: "Twitter link",
          instagram: "Instagram link",
          linkedin: "LinkedIn link"
        }
      }
    },
    purpleHeartAlt: "Purposely's purple heart"
  }
}